<template>
    <div class="col-md-12 mx-auto">
        <div class="card mt-12">
            <div class="card-body">
                <kendo-datasource ref="organizationalModelDatasource"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='gridOptions.pageable.size'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd">
                </kendo-datasource>

                <kendo-grid ref="organizationalModelGrid"
                            data-source-ref="organizationalModelDatasource"
                            :navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="toolbar"
                            :excel="gridOptions.excel"
                            :pdf="gridOptions.pdf">
                    <kendo-grid-column :field="'id'"
                                       :filterable="false"
                                       :title="$t('organizationalModelItem.gridHeaders.id')"
                                       :hidden="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'categoryModel'"
                                       :title="$t('organizationalModelItem.gridHeaders.categoryDisplayName')"
                                       :editor="categoryIdDropDownEditor"
                                       :template="categoryCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'name'"
                                       :title="$t('organizationalModelItem.gridHeaders.name')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'nameEn'"
                                       :title="$t('organizationalModelItem.gridHeaders.nameEn')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'benchmarkType'"
                                       :title="$t('organizationalModelItem.gridHeaders.benchmarkType')"
                                       :editor="benchmarkTypeIdDropDownEditor"
                                       :template="benchmarkTypeCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'deadlineToAfterBenchemarkIdDays'"
                                       :title="$t('organizationalModelItem.gridHeaders.deadlineToAfterBenchemarkIdDays')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'priorAlertDeadlineInDays'"
                                       :title="$t('organizationalModelItem.gridHeaders.priorAlertDeadlineInDays')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'expectedResult'"
                                       :title="$t('organizationalModelItem.gridHeaders.expectedResult')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'deactivated'"
                                       :title="$t('organizationalModelItem.gridHeaders.deactivated')"
                                       :hidden="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'active'"
                                       :template="activeCellTemplate"
                                       :title="$t('organizationalModelItem.gridHeaders.active')">
                    </kendo-grid-column>
                    <kendo-grid-column :command="command">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import JSZip from 'jszip'
    import { OrganizationalModel } from '../../models/models';
    import { Culture } from '../../models/enums';

    /*
    Renders the grid in "DejaVu Sans" font family, which is
    declared in kendo.common.css. It also declares the paths to the
    fonts below using <tt>kendo.pdf.defineFont</tt>, because the
    stylesheet is hosted on a different domain.
    */
    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });

    export default {
        components: {

        },
        props: {
            showBtns: {
                default: true,
                type: Boolean
            },
            organizationalModel: {
                type: OrganizationalModel,
                required: true,
            },
        },
        created() {
            window.JSZip = JSZip;
        },
        data() {
            return {
                componentName: "organizationModelItems",
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true },
                    name: { name: 'name', type: 'string', editable: true, nullable: false, visible: true, validation: { required: true } },
                    nameEn: { name: 'nameEn', type: 'string', editable: true, nullable: true, visible: true },
                    categoryModel: {
                        defaultValue: { id: 0, text: 'Избери...', textEx: 'Select...' },
                        validation: {
                            required: true,
                            textvalidation: function (input) {
                                if (input.is("[name='categoryModel']")) {
                                    let val = Number(input.val());
                                    if (isNaN(val) || val === 0) {
                                        input.attr("data-textvalidation-msg", this.$t('validation.requiredField'));
                                        return /^[A-Z]/.test(input.val());
                                    }
                                }

                                return true;
                            }.bind(this)
                        }
                    },
                    benchmarkType: {
                        defaultValue: { id: 0, text: 'Избери...', textEx: 'Select...' },
                        validation: {
                            required: true,
                            textvalidation: function (input) {
                                if (input.is("[name='benchmarkType']")) {
                                    let val = Number(input.val());
                                    if (isNaN(val) || val === 0) {
                                        input.attr("data-textvalidation-msg", this.$t('validation.requiredField'));
                                        return /^[A-Z]/.test(input.val());
                                    }
                                }

                                return true;
                            }.bind(this)
                        }
                    },
                    deadlineToAfterBenchemarkIdDays: { name: 'deadlineToAfterBenchemarkIdDays', type: 'number', editable: true, nullable: false, visible: true, validation: { min: -365, max: 365, step: 1 } },
                    priorAlertDeadlineInDays: { name: 'priorAlertDeadlineInDays', type: 'number', editable: true, nullable: false, visible: true, validation: { min: -365, max: 365, step: 1 } },
                    expectedResult: { name: 'expectedResult', type: 'string', editable: true, nullable: true, visible: true },
                    active: { name: 'active', type: 'boolean', editable: false, nullable: false, visible: true },
                    deactivated: { name: 'deactivated', type: 'boolean', editable: true, nullable: false, visible: false },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/organizationalModel/listItems',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    create: {
                        url: this.$store.getters.baseUrl + '/api/organizationalModel/createModelItem',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: this.$store.getters.baseUrl + '/api/organizationalModel/updateModelItem',
                        dataType: 'json',
                        type: 'PUT',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    destroy: {
                        url: this.$store.getters.baseUrl + '/api/organizationalModel/deleteModelItem',
                        dataType: 'json',
                        type: 'DELETE',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    editable: {
                        mode: 'popup',
                        window: {
                            title: this.$t('organizationalModelItem.title'),
                            animation: true
                        },
                        move: false
                    },
                    excel: {
                        fileName: 'OrganizationalModelItems.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'OrganizationalModelItems.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                }
            };
        },
        methods: {
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    let newOptions = { id: this.organizationalModel.id, request: options, model: options };
                    return kendo.stringify(newOptions);
                }
            },
            dataSourceError(e) {
                if (e.sender) {
                    e.sender.read();
                }

                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            datasorceRequestEnd(e) {
                if (e.type === "create" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type === "update" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type === "destroy" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            categoryCellTemplate: function (dataItem) {
                if (dataItem.categoryModel === null) {
                    return kendo.htmlEncode("");
                }

                if (dataItem.categoryModel.text === null && dataItem.categoryModel.textEn === null) {
                    return kendo.htmlEncode("");
                }

                let templateHtml = '<span>' + kendo.htmlEncode(this.isEnVersion ? dataItem.categoryModel.textEn : dataItem.categoryModel.text) + '</span>';

                return templateHtml;
            },
            categoryIdDropDownEditor: function (container, options) {
                $('<input name="' + options.field + '"/> id="' + options.field + '"')
                    .appendTo(container)
                    .kendoDropDownList({
                        autoBind: false,
                        dataTextField: this.isEnVersion ? 'textEn' : 'text',
                        dataValueField: "id",
                        optionLabel: this.$t('selectCategory'),
                        dataSource: {
                            transport: {
                                read: {
                                    url: this.$store.getters.baseUrl + '/api/organizationalModel/categoryDropdownSource',
                                    dataType: 'json',
                                    type: 'GET',
                                    contentType: 'application/json',
                                    beforeSend: this.beforeSend
                                },
                            }
                        }
                    });
            },
            benchmarkTypeCellTemplate: function (dataItem) {
                if (dataItem.benchmarkType === null) {
                    return kendo.htmlEncode("");
                }

                if (dataItem.benchmarkType.text === null && dataItem.benchmarkType.textEn === null) {
                    return kendo.htmlEncode("");
                }

                let templateHtml = '<span>' + kendo.htmlEncode(this.isEnVersion ? dataItem.benchmarkType.textEn : dataItem.benchmarkType.text) + '</span>';

                return templateHtml;
            },
            benchmarkTypeIdDropDownEditor: function (container, options) {
                $('<input name="' + options.field + '"/> id="' + options.field + '"')
                    .appendTo(container)
                    .kendoDropDownList({
                        autoBind: false,
                        dataTextField: this.isEnVersion ? 'textEn' : 'text',
                        dataValueField: "id",
                        optionLabel: this.$t('selectBenchmark'),
                        dataSource: {
                            transport: {
                                read: {
                                    url: this.$store.getters.baseUrl + '/api/organizationalModel/benchmarkTypeDropdownSource',
                                    dataType: 'json',
                                    type: 'GET',
                                    contentType: 'application/json',
                                    beforeSend: this.beforeSend
                                },
                            }
                        }
                    });
            },
        },
        mounted: function () {

        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            toolbar: function () {
                return [{ name: 'create', text: this.$t('buttons.create.btnText') },
                { name: 'pdf', text: this.$t('buttons.pdfExport.tooltipText') },
                { name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
            command: function () {
                return [{ name: 'edit', text: this.$t('buttons.edit.btnText') },
                { name: 'destroy', text: this.$t('buttons.delete.btnText') }]
            },
            group() {
                return {};
            },
        }
    }
</script>

<style scoped>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: "DejaVu Sans", "Arial", sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
